import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDeleteAction } from '../../../../ts/ServerApi/types/actionNames';
import { removeExternalContentAction } from '../../../actions/RemoveExternalContentAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RemoveExternalContentAction: IEntityAction<IContentInfo, IDeleteAction> = {
  name: EntityActionNames.RemoveExternalContent,
  translateName: Messages.remove_action,
  isVisible: (_, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.removeExternalContentEnabled,
  isClickable: (availableActions: IDeleteAction) => !!(availableActions && availableActions.del),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('removeExternalContent was called without exactly one item');
    }

    const item = items[0];

    switch(item.contentType) {
      case 'database':
        return removeExternalContentAction(item as IContentInfo<'database'>);
      case 'table':
        return removeExternalContentAction(item as IContentInfo<'table'>);
      default:
        throw new Error('removeExternalContent is only valid for database and table content types');
    }
  }
};
